import React from "react"
import { Button, Modal } from "react-bootstrap"

const CancelApplicationModal = ({
  show,
  onHide,
  onConfirm,
}: {
  show: boolean
  onHide: () => void
  onConfirm: () => void
}): JSX.Element => (
  <Modal show={show} onHide={onHide} aria-labelledby="cancel-application-modal-title" centered>
    <Modal.Header closeButton>
      <Modal.Title id="cancel-application-modal-title">Cancel application?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        This will permanently delete your draft application. Any questionnaire responses you have
        entered will be discarded.
      </p>
      <p className="mb-0">The cruise line will not be notified.</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Keep application
      </Button>
      <Button
        variant="danger"
        onClick={() => {
          onConfirm()
          onHide()
        }}
      >
        Cancel application
      </Button>
    </Modal.Footer>
  </Modal>
)

export default CancelApplicationModal
